import { BrailleLoader } from '~/components/ui/braille-loader';
import { cn } from '~/lib/utils';

/**
 * The single spinner component for the app — orbit BrailleLoader in current text color
 * (near-black in chrome; light on filled buttons).
 *
 * Convention (see portal/AGENTS.md):
 * - App boot                    -> `AppBootLoader` (full-screen "P" + green Lottie)
 * - Route/page transitions      -> `ContentPaneLoader` (Protege logomark, centered)
 * - Inline data loading         -> `AppSpinner`
 */
export type AppSpinnerSize = 'xs' | 'sm' | 'md' | 'lg';

export interface AppSpinnerProps {
  size?: AppSpinnerSize;
  isCentered?: boolean;
  className?: string;
}

const fontSize: Record<AppSpinnerSize, number> = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 28,
};

export default function AppSpinner({ size = 'lg', isCentered = false, className }: AppSpinnerProps) {
  const spinner = (
    <BrailleLoader
      variant="orbit"
      speed="normal"
      fontSize={fontSize[size]}
      className={cn('text-current', className)}
    />
  );

  if (isCentered) {
    return (
      <div className="absolute flex h-full w-full items-center justify-center">{spinner}</div>
    );
  }

  return spinner;
}
